// Centralized frontend runtime config.
const getRequired = (name: string): string => {
  const value = import.meta.env[name];
  if (!value || typeof value !== 'string') {
    throw new Error(`Missing required environment variable: ${name}`);
  }
  return value;
};

const getOptional = (name: string): string | undefined => {
  const value = import.meta.env[name];
  return value && typeof value === 'string' ? value : undefined;
};

export const env = {
  VITE_APP_ENV: getOptional('VITE_APP_ENV'),
  VITE_AWS_ACCOUNT_ID: getOptional('VITE_AWS_ACCOUNT_ID'),
  VITE_PRIMARY_DOMAIN: getOptional('VITE_PRIMARY_DOMAIN'),
  VITE_EMAIL_DOMAIN_BASE: getOptional('VITE_EMAIL_DOMAIN_BASE'),
  VITE_EMAIL_AUTH_DOMAIN: getOptional('VITE_EMAIL_AUTH_DOMAIN'),
  VITE_EMAIL_NOTIFY_DOMAIN: getOptional('VITE_EMAIL_NOTIFY_DOMAIN'),
  VITE_EMAIL_FROM_AUTH: getOptional('VITE_EMAIL_FROM_AUTH'),
  VITE_EMAIL_FROM_NOTIFY: getOptional('VITE_EMAIL_FROM_NOTIFY'),
  VITE_VERIFICATION_RESEND_COOLDOWN_SECONDS: getOptional('VITE_VERIFICATION_RESEND_COOLDOWN_SECONDS'),
  VITE_DEBUG_PAYLOAD_DIALOGS_ENABLED: getOptional('VITE_DEBUG_PAYLOAD_DIALOGS_ENABLED'),
  VITE_E2E_CAPTURE_VERIFICATION_LINK: getOptional('VITE_E2E_CAPTURE_VERIFICATION_LINK'),
  VITE_SUPABASE_URL: getRequired('VITE_SUPABASE_URL'),
  VITE_SUPABASE_PUBLISHABLE_KEY: getRequired('VITE_SUPABASE_PUBLISHABLE_KEY'),
};
